











import { Vue, Component } from 'vue-property-decorator';
import { language, reportIndexPvUvAndTimeCost } from '@tencent/ppd-base-libs';
import PageTab from './components/page-tab/index.vue';
import { reportPerformance, setTiming } from '@/business/performance';

@Component({
  components: {
    PageTab,
  },
})
export default class App extends Vue {
  public lang = language.getLanguage();
  // bi触发
  biTrigger = false;
  // bi扩展字段
  biExt = {};
  public async created() {
    const htmlEl = document.getElementsByTagName('html') as any;
    reportIndexPvUvAndTimeCost();
    setTiming('viewHome');
    reportPerformance();
    document.body.classList.add(this.lang);
    const lang = this.lang === 'en' ? 'en' : 'zh';
    htmlEl[0].setAttribute('lang', lang);
  }

  // 处理滚动添加scroll埋点需要的信息
  handleScroll() {
    if (!this.biTrigger) {
      this.biTrigger = true;
      this.biExt = {
        fpageUrl: this.$route.name,
      };
    }
  }

  mounted() {
    document.getElementById('app')?.addEventListener('scroll', this.handleScroll);
  }

  destroyed() {
    document.getElementById('app')?.removeEventListener('scroll', this.handleScroll);
  }
}
